import { EStatusMatches } from '@/app/pages/sports/football/enums';
import { ScreenService } from '@/app/services/media-screen/screen.service';
import { TranslationService } from '@/app/services/translation.service';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { RouterLink } from '@angular/router';

interface ITeam {
  id: string;
  name: string;
  logo: string;
  score: number;
  halfScore: number | null;
  penaltyScore: number | null;
  nameTranslation: Record<string, string> | null;
  tsExternalId: string;
}

@Component({
  selector: 'app-away-team',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './away-team.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AwayTeamComponent {
  private translateService = inject(TranslationService);
  screenService = inject(ScreenService);

  awayTeam = input<ITeam>();
  isWin = input.required<boolean>();
  matchStatus = input.required<string>();
  countryName = input.required<string | null>();

  getLogoImg(): string {
    return this.awayTeam()?.logo || '';
  }

  getUrlTeam() {
    return this.translateService.getTraslateUrlTeamDetails(
      {
        en: this.awayTeam()?.nameTranslation?.['en'],
        es: this.awayTeam()?.nameTranslation?.['es'],
      },
      this.awayTeam()?.name ?? '',
      this.awayTeam()?.id ?? ''
    );
  }

  isLiveMatch(): boolean {
    return this.matchStatus() === EStatusMatches.NORMAL;
  }

  getTraduccionName(): string {
    const lang = this.translateService.getLangLocalStorage();
    const translation = this.awayTeam()?.nameTranslation?.[lang];
    return translation?.trim() ? translation : this.awayTeam()?.name!;
  }
}
